import React, { useState, useEffect } from "react";
import { Popover, Button, Text, Group, Menu, ActionIcon } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import FilterDropdownFieldSelector from "./FilterDropdownFieldSelector";

export default function FilterDropdownSortSelector({ filters, sortSelected, onUpdateSort }) {
  const [openedValue, setOpenedValue] = useState(false);

  const sortList = Array.isArray(sortSelected) ? sortSelected : [];
  const sortItem = sortList[0];
  const sortNames = sortList.map((sort) => sort.name).join(", ");

  const onSelectFilter = (filter) => {
    onUpdateSort([{...filter, sort_order: "desc"}]);
    setOpenedValue(true);
  };

  const TargetComponent = ({ onClick }) => (
    <Button
      variant="default"
      onClick={onClick}
      leftIcon={
        sortItem ? (
          <FontAwesomeIcon
            icon={sortItem.sort_order === "asc" ? solid("arrow-up") : solid("arrow-down")}
            color="grey"
            size="sm"
          />
        ) : undefined
      }
      rightIcon={<FontAwesomeIcon icon={solid("chevron-down")} color="grey" size="sm" />}
      radius="md"
      size="xs"
    >
      <Text color="grey" size="xs">{sortList.length > 0 ? sortNames : "Sort by..."}</Text>
    </Button>
  );

  return (
    <>
      {sortList.length === 0 ? (
        <FilterDropdownFieldSelector
          filters={filters}
          TargetComponent={({ onClick}) => <TargetComponent onClick={onClick} />}
          onSelectFilter={onSelectFilter}
        />
      ) : (
        <Popover
          opened={openedValue}
          onClose={() => setOpenedValue(false)}
          spacing={0}
          position="bottom"
          placement="start"
          radius="md"
          target={<TargetComponent onClick={() => setOpenedValue(!openedValue)} />}
        >
          {sortList.map((item, key) => (
            <Group spacing={8} p={8} key={key}>
              <FilterDropdownFieldSelector
                filters={filters}
                TargetComponent={({ onClick }) => (
                  <Button
                    variant="default"
                    size="xs"
                    rightIcon={<FontAwesomeIcon icon={solid("chevron-down")} color="grey" size="sm" />}
                    radius="md"
                    onClick={onClick}
                  >
                    <Text size="xs" color="grey" style={{ textTransform: "capitalize" }}>
                      {item.name}
                    </Text>
                  </Button>
                )}
                onSelectFilter={onSelectFilter}
              />
              <Menu
                withinPortal={false}
                control={
                  <Button
                    variant="default"
                    size="xs"
                    rightIcon={<FontAwesomeIcon icon={solid("chevron-down")} color="grey" size="sm" />}
                    radius="md"
                  >
                    <Text size="xs" color="grey">{item.sort_order === "asc" ? "Ascending" : "Descending"}</Text>
                  </Button> 
                }
              >
                {[
                  { value: "desc", label: "Descending" },
                  { value: "asc", label: "Ascending" }
                ].map((option, optionKey) => (
                  <Menu.Item
                    key={optionKey}
                    rightSection={item.sort_order === option.value ? <FontAwesomeIcon icon={solid("check")} size="xs" /> : undefined}
                    onClick={() => onUpdateSort([{...item, sort_order: option.value}])}
                  >
                    {option.label}
                  </Menu.Item>
                ))}
              </Menu>
              <ActionIcon
                onClick={() => {
                  onUpdateSort(null);
                  setOpenedValue(false);
                }}
              >
                <FontAwesomeIcon icon={solid("close")} color="grey" size="sm" />
              </ActionIcon>
            </Group>
          ))}
        </Popover>
      )}
    </>
  );
}